import { axiosInstance } from '../Config/axios';

const ROLES_URL = 'v1/access/roles/';
const VIEW_URL = 'v1/access/views/';
const ROLES_DELETED_URL = 'v1/access/roles-deleted/';

export const getRoles = async () => {
  try {
    const response = await axiosInstance.get(ROLES_URL);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los roles", error);
    throw error;
  }
};

// Obtener un rol en particular
export const getRoleById = async (id) => {
  try {
    const response = await axiosInstance.get(`${ROLES_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el rol con ID ${id}:`, error);
    throw error;
  }
};

// Función para crear un nuevo rol (POST)
export const createRole = async (userData) => {
  try {
    const response = await axiosInstance.post(ROLES_URL, userData);
    return response.data;
  } catch (error) {
    console.error('Error al crear el rol:', error);
    throw error;
  }
};

// Función para actualizar un rol (PUT)
export const updateRole = async (id, userData) => {
  try {
    const response = await axiosInstance.put(`${ROLES_URL}${id}/`, userData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el rol:', error);
    throw error;
  }
};

// Función para eliminar un rol (DELETE)
export const deleteRole = async (id) => {
  try {
    await axiosInstance.delete(`${ROLES_URL}${id}/`);
  } catch (error) {
    console.error('Error al eliminar el rol:', error);
    throw error;
  }
};

// Función para listar los usuarios eliminados (GET)
export const getRolesDeleted = async () => {
  try {
    const response = await axiosInstance.get(ROLES_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los roles eliminados:', error);
    throw error;
  }
};

// Obtener una activo eliminado por código (GET)
export const getRoleDeletedByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${ROLES_DELETED_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el rol eliminado con código ${code}:`, error);
    throw error;
  }
};

// VISTAS
export const getViews = async () => {
  try {
    const response = await axiosInstance.get(VIEW_URL);
    return response.data;
  } catch (error) {
    console.error("Error al obtener las vistas", error);
    throw error;
  }
};

